(function () {
    'use strict';

    angular
        .module('admin')
        .controller('UserListController', UserListController)

    UserListController.$inject = ['users', 'UserService'];


    function UserListController(users, UserService) {
        var vm = this;

        vm.users            = users.data;
        vm.edit             = edit;
        vm.remove           = remove;

        
        function activate() {

        }

        function edit ($id) {

        }

        function remove (user) {
            alertify
                .confirm('This action is irreversible!')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancelar'
                })
                .set('title', 'Do you really want to delete this user ' + user.name+'?')
                .set('onok', function (){

                    UserService.remove(user.id).then(function () {
                        vm.users.splice(vm.users.indexOf(user), 1);
                        alertify.notify('Usuário apagado', 'success', 3);
                    });
                })
                .show();
        }
        activate();
    }
})();